import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'create-appointment', [
  'START',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'providers',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['providerUserId'],
    },
    'patients',
    {
      type: 'payload',
      selector: ['patientUserId'],
    },
    'appointments',
  ],
});

export default createReqReducer(consts);

// POST /api/providers/:provider_user_id/patients/:patient_user_id/appointments



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/create-apppointment-req.js